"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[6278],{

/***/ 15347:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "oT": function() { return /* reexport */ Tabs_Control_Control; },
  "s_": function() { return /* reexport */ Tabs_Panel_Panel; },
  "fQ": function() { return /* reexport */ Tabs_Track_Track; },
  "ZP": function() { return /* binding */ recipes_Tabs; },
  "gC": function() { return /* reexport */ useTabsContext; }
});

// UNUSED EXPORTS: Tabs, TabsContext, TabsProvider

// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
;// CONCATENATED MODULE: ../../libs/matcha/recipes/Tabs/TabsContext.ts

var TabsContext = /*#__PURE__*/(0,react.createContext)({
  variant: "filled"
});
var TabsProvider = TabsContext.Provider;
var useTabsContext = function useTabsContext() {
  var context = (0,react.useContext)(TabsContext);

  if (!context) {
    throw new Error("useTabsContext must be used within a TabsContext.Provider");
  }

  return context;
};
// EXTERNAL MODULE: ../../node_modules/@emotion/react/jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.js
var emotion_react_jsx_runtime_browser_esm = __webpack_require__(52903);
;// CONCATENATED MODULE: ../../libs/matcha/recipes/Tabs/Tabs/Tabs.tsx


var Tabs = function Tabs(_ref) {
  var variant = _ref.variant,
      children = _ref.children;
  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(TabsProvider, {
    value: {
      variant: variant
    },
    children: children
  });
};
/* harmony default export */ var Tabs_Tabs = (Tabs);
;// CONCATENATED MODULE: ../../libs/matcha/recipes/Tabs/Tabs/index.ts


// EXTERNAL MODULE: ../../node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(95235);
// EXTERNAL MODULE: ../../node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js + 1 modules
var objectWithoutProperties = __webpack_require__(82269);
// EXTERNAL MODULE: ../../libs/matcha/useDesignTokens/index.ts
var useDesignTokens = __webpack_require__(98439);
// EXTERNAL MODULE: ../../node_modules/@emotion/styled/base/dist/emotion-styled-base.browser.esm.js
var emotion_styled_base_browser_esm = __webpack_require__(92952);
// EXTERNAL MODULE: ../../node_modules/framer-motion/dist/es/render/dom/motion-minimal.mjs + 21 modules
var motion_minimal = __webpack_require__(48714);
// EXTERNAL MODULE: ../../node_modules/@emotion/react/dist/emotion-react.browser.esm.js
var emotion_react_browser_esm = __webpack_require__(28165);
;// CONCATENATED MODULE: ../../libs/matcha/recipes/Tabs/Control/Control.views.tsx


function _EMOTION_STRINGIFIED_CSS_ERROR__() {
  return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}



var Control = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("button",  true ? {
  target: "e1enw1t52"
} : 0)("display:block;position:relative;white-space:nowrap;transition:color 0.2s ease-in;color:", function (_ref) {
  var color = _ref.color;
  return color;
}, ";cursor:pointer;", function (_ref2) {
  var variant = _ref2.variant,
      size = _ref2.size,
      outlineColor = _ref2.outlineColor,
      theme = _ref2.theme;

  switch (variant) {
    case "filled":
      return (
        /*#__PURE__*/

        /*#__PURE__*/
        (0,emotion_react_browser_esm/* css */.iv)("padding:", size === "lg" ? "16px 24px" : "12px 24px", ";", size === "lg" &&
        /*#__PURE__*/

        /*#__PURE__*/
        (0,emotion_react_browser_esm/* css */.iv)(theme.typography.textBoldSmall, ";" + ( true ? "" : 0),  true ? "" : 0,  true ? "" : 0,  true ? "" : 0), " ", size === "sm" &&
        /*#__PURE__*/

        /*#__PURE__*/
        (0,emotion_react_browser_esm/* css */.iv)(theme.typography.textTiny, ";" + ( true ? "" : 0),  true ? "" : 0,  true ? "" : 0,  true ? "" : 0), " &:hover{text-decoration:underline;text-underline-offset:4px;}&:focus-visible{outline:2px solid ", outlineColor, ";outline-offset:2px;}" + ( true ? "" : 0),  true ? "" : 0,  true ? "" : 0,  true ? "" : 0)
      );

    case "lined":
    default:
      return (
        /*#__PURE__*/

        /*#__PURE__*/
        (0,emotion_react_browser_esm/* css */.iv)("padding:0 0 15px 0;", theme.typography.textBoldSmall, " ", theme.breakpoints.up("sm"), "{", theme.typography.textBold, ";}" + ( true ? "" : 0),  true ? "" : 0,  true ? "" : 0,  true ? "" : 0)
      );
  }
}, " &:hover{color:", function (_ref3) {
  var hoverColor = _ref3.hoverColor;
  return hoverColor;
}, ";}" + ( true ? "" : 0));
var Highlight = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(motion_minimal.m.div,  true ? {
  target: "e1enw1t51"
} : 0)("position:absolute;right:0;bottom:0;left:0;", function (_ref4) {
  var variant = _ref4.variant,
      borderColor = _ref4.borderColor;
  return variant === "filled" &&
  /*#__PURE__*/

  /*#__PURE__*/
  (0,emotion_react_browser_esm/* css */.iv)("top:0;border-radius:5px;border:", "2px solid ".concat(borderColor), ";" + ( true ? "" : 0),  true ? "" : 0,  true ? "" : 0,  true ? "" : 0);
}, " ", function (_ref5) {
  var variant = _ref5.variant,
      theme = _ref5.theme;
  return variant === "lined" &&
  /*#__PURE__*/

  /*#__PURE__*/
  (0,emotion_react_browser_esm/* css */.iv)("height:2px;", theme.breakpoints.up("sm"), "{height:1px;}" + ( true ? "" : 0),  true ? "" : 0,  true ? "" : 0,  true ? "" : 0);
}, " background-color:", function (_ref6) {
  var backgroundColor = _ref6.backgroundColor;
  return backgroundColor;
}, ";border-radius:100px;" + ( true ? "" : 0));
var Text = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("span",  true ? {
  target: "e1enw1t50"
} : 0)( true ? {
  name: "179t5g5",
  styles: "position:relative;z-index:1"
} : 0);
;// CONCATENATED MODULE: ../../libs/matcha/recipes/Tabs/Control/Control.tsx


var _excluded = ["tokens", "active", "variant", "size", "children"];

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      (0,defineProperty/* default */.Z)(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }

  return target;
}







var BaseControl = /*#__PURE__*/(0,react.forwardRef)(function (_ref, ref) {
  var tokens = _ref.tokens,
      _ref$active = _ref.active,
      active = _ref$active === void 0 ? false : _ref$active,
      extVariant = _ref.variant,
      _ref$size = _ref.size,
      size = _ref$size === void 0 ? "lg" : _ref$size,
      children = _ref.children,
      rest = (0,objectWithoutProperties/* default */.Z)(_ref, _excluded);

  var _useTabsContext = useTabsContext(),
      globalVariant = _useTabsContext.variant;

  var variant = extVariant !== null && extVariant !== void 0 ? extVariant : globalVariant;
  return (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Control, _objectSpread(_objectSpread(_objectSpread({
    ref: ref,
    variant: variant,
    size: size
  }, tokens.root), rest), {}, {
    children: [active && (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Highlight, _objectSpread({
      variant: variant,
      layoutId: "highlight"
    }, tokens.highlight)), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Text, {
      children: children
    })]
  }));
});
var Control_Control = (0,useDesignTokens/* withDesignTokens */.Y)(BaseControl, function () {
  return {};
}, {
  light: function light(theme, _ref2) {
    var extVariant = _ref2.variant,
        active = _ref2.active;

    var _useTabsContext2 = useTabsContext(),
        globalVariant = _useTabsContext2.variant;

    var variant = extVariant !== null && extVariant !== void 0 ? extVariant : globalVariant;
    var color = theme.palette.twilio.gray[40];

    switch (variant) {
      case "filled":
        return {
          root: {
            color: theme.palette.brand.boysenberry[500],
            hoverColor: theme.palette.brand.boysenberry[600],
            outlineColor: theme.palette.brand.boysenberry[400]
          },
          highlight: {
            backgroundColor: theme.palette.neutrals.white[100],
            borderColor: theme.palette.brand.boysenberry[500]
          }
        };

      case "lined":
      default:
        return {
          root: {
            color: active ? theme.palette.brand.boysenberry[500] : color,
            hoverColor: theme.palette.brand.boysenberry[600],
            outlineColor: "transparent"
          },
          highlight: {
            backgroundColor: theme.palette.brand.boysenberry[500]
          }
        };
    }
  },
  twilioLight: function twilioLight(theme, _ref3) {
    var extVariant = _ref3.variant,
        active = _ref3.active;

    var _useTabsContext3 = useTabsContext(),
        globalVariant = _useTabsContext3.variant;

    var variant = extVariant !== null && extVariant !== void 0 ? extVariant : globalVariant;
    var color = theme.palette.twilio.gray[40];

    switch (variant) {
      case "filled":
        return {
          root: {
            color: theme.palette.twilio.blue[60],
            hoverColor: theme.palette.twilio.blue[70],
            outlineColor: theme.palette.twilio.blue[40]
          },
          highlight: {
            backgroundColor: theme.palette.neutrals.white[100],
            borderColor: theme.palette.twilio.blue[60]
          }
        };

      case "lined":
      default:
        return {
          root: {
            color: active ? theme.palette.twilio.blue[60] : color,
            hoverColor: theme.palette.twilio.blue[60],
            outlineColor: "transparent"
          },
          highlight: {
            backgroundColor: theme.palette.twilio.blue[60]
          }
        };
    }
  }
});
/* harmony default export */ var Tabs_Control_Control = (Control_Control);
;// CONCATENATED MODULE: ../../libs/matcha/recipes/Tabs/Control/index.ts

;// CONCATENATED MODULE: ../../libs/matcha/recipes/Tabs/Panel/Panel.views.ts


function Panel_views_EMOTION_STRINGIFIED_CSS_ERROR_() {
  return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}


var Panel = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(motion_minimal.m.div,  true ? {
  target: "emvqar30"
} : 0)( true ? {
  name: "1d3w5wq",
  styles: "width:100%"
} : 0);
;// CONCATENATED MODULE: ../../libs/matcha/recipes/Tabs/Panel/Panel.tsx


var Panel_excluded = ["children", "active", "tokens"];

function Panel_ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }

  return keys;
}

function Panel_objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? Panel_ownKeys(Object(source), !0).forEach(function (key) {
      (0,defineProperty/* default */.Z)(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : Panel_ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }

  return target;
}





var enterAnimation = {
  opacity: 1,
  zIndex: 1,
  pointerEvents: "auto",
  y: 0,
  visibility: "initial"
};
var exitAnimation = {
  opacity: 0,
  zIndex: 0,
  pointerEvents: "none",
  y: -30,
  visibility: "hidden"
};
var initialAnimation = {
  opacity: 0,
  zIndex: 0,
  pointerEvents: "none",
  y: -30,
  visibility: "initial"
};
var motionProps = {
  initial: initialAnimation,
  animate: enterAnimation,
  exit: exitAnimation,
  transition: {
    type: "tween",
    ease: "easeInOut",
    duration: 0.3
  }
};
var BasePanel = /*#__PURE__*/(0,react.forwardRef)(function (_ref, ref) {
  var children = _ref.children,
      active = _ref.active,
      tokens = _ref.tokens,
      rest = (0,objectWithoutProperties/* default */.Z)(_ref, Panel_excluded);

  var animation = active === undefined ? motionProps.animate : active ? enterAnimation : exitAnimation;
  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Panel, Panel_objectSpread(Panel_objectSpread(Panel_objectSpread(Panel_objectSpread({
    ref: ref
  }, motionProps), {}, {
    animate: animation
  }, tokens), rest), {}, {
    children: children
  }));
});
var Panel_Panel = (0,useDesignTokens/* withDesignTokens */.Y)(BasePanel, function () {
  return {};
}, {
  twilioLight: function twilioLight() {
    return {};
  },
  dark: function dark() {
    return {};
  },
  light: function light() {
    return {};
  }
});
/* harmony default export */ var Tabs_Panel_Panel = (Panel_Panel);
;// CONCATENATED MODULE: ../../libs/matcha/recipes/Tabs/Panel/index.ts

// EXTERNAL MODULE: ../../node_modules/framer-motion/dist/es/components/LayoutGroup/index.mjs + 2 modules
var LayoutGroup = __webpack_require__(28957);
// EXTERNAL MODULE: ../../libs/utils/useMaskOnScroll/index.ts + 1 modules
var useMaskOnScroll = __webpack_require__(63009);
;// CONCATENATED MODULE: ../../libs/matcha/recipes/Tabs/Track/Track.views.ts


function Track_views_EMOTION_STRINGIFIED_CSS_ERROR_() {
  return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}




var _ref2 =  true ? {
  name: "mxpsp9",
  styles: "height:calc(100% - 8px)"
} : 0;

var Track = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(motion_minimal.m.div,  true ? {
  shouldForwardProp: function shouldForwardProp(prop) {
    return prop !== "lineColor";
  },
  target: "eehbsdv2"
} : 0)("position:relative;display:grid;place-content:center;width:fit-content;::before{content:'';position:absolute;background-color:", function (_ref3) {
  var backgroundColor = _ref3.backgroundColor;
  return backgroundColor;
}, ";border-radius:100px;width:calc(100% - 8px);left:4px;bottom:4px;", function (_ref4) {
  var variant = _ref4.variant;
  return variant === "filled" && _ref2;
}, " ", function (_ref5) {
  var variant = _ref5.variant,
      theme = _ref5.theme;
  return variant === "lined" &&
  /*#__PURE__*/

  /*#__PURE__*/
  (0,emotion_react_browser_esm/* css */.iv)("height:2px;", theme.breakpoints.up("sm"), "{height:1px;}" + ( true ? "" : 0),  true ? "" : 0,  true ? "" : 0,  true ? "" : 0);
}, ";}" + ( true ? "" : 0));
var Mask = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(motion_minimal.m.div,  true ? {
  target: "eehbsdv1"
} : 0)( true ? "" : 0);

var _ref =  true ? {
  name: "1l0tq1w",
  styles: "gap:8px"
} : 0;

var Container = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "eehbsdv0"
} : 0)("position:relative;display:grid;grid-auto-flow:column;grid-auto-columns:min-content;width:100%;margin:0 auto;scroll-snap-type:x proximity;scrollbar-width:none;overflow-y:hidden;padding:4px;::-webkit-scrollbar{display:none;}", function (_ref6) {
  var variant = _ref6.variant;
  return variant === "filled" && _ref;
}, ";", function (_ref7) {
  var variant = _ref7.variant,
      theme = _ref7.theme;
  return variant === "lined" &&
  /*#__PURE__*/

  /*#__PURE__*/
  (0,emotion_react_browser_esm/* css */.iv)("gap:24px;", theme.breakpoints.up("sm"), "{gap:48px;}" + ( true ? "" : 0),  true ? "" : 0,  true ? "" : 0,  true ? "" : 0);
}, ";" + ( true ? "" : 0));
;// CONCATENATED MODULE: ../../libs/matcha/recipes/Tabs/Track/Track.tsx


var Track_excluded = ["className", "tokens", "variant", "children"];

function Track_ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }

  return keys;
}

function Track_objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? Track_ownKeys(Object(source), !0).forEach(function (key) {
      (0,defineProperty/* default */.Z)(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : Track_ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }

  return target;
}








var BaseTrack = /*#__PURE__*/(0,react.forwardRef)(function (_ref, ref) {
  var className = _ref.className,
      tokens = _ref.tokens,
      extVariant = _ref.variant,
      children = _ref.children,
      rest = (0,objectWithoutProperties/* default */.Z)(_ref, Track_excluded);

  var scrollableContainerRef = (0,react.useRef)(null);
  var id = (0,react.useId)();

  var _useTabsContext = useTabsContext(),
      globalVariant = _useTabsContext.variant;

  var variant = extVariant !== null && extVariant !== void 0 ? extVariant : globalVariant;
  (0,react.useImperativeHandle)(ref, function () {
    return scrollableContainerRef.current;
  });
  var maskOnScroll = (0,useMaskOnScroll/* default */.Z)({
    wrapper: scrollableContainerRef
  });
  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Mask, {
    className: className,
    style: {
      WebkitMaskImage: maskOnScroll,
      maskImage: maskOnScroll
    },
    children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Track, Track_objectSpread(Track_objectSpread({}, tokens), {}, {
      variant: variant,
      children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Container, Track_objectSpread(Track_objectSpread({
        variant: variant,
        ref: scrollableContainerRef,
        "data-testid": "Track[container]"
      }, rest), {}, {
        children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(LayoutGroup/* LayoutGroup */.S, {
          id: id,
          children: children
        })
      }))
    }))
  });
});
var Track_Track = (0,useDesignTokens/* withDesignTokens */.Y)(BaseTrack, function () {
  return {};
}, {
  light: function light(theme, _ref2) {
    var extVariant = _ref2.variant;

    var _useTabsContext2 = useTabsContext(),
        globalVariant = _useTabsContext2.variant;

    var variant = extVariant !== null && extVariant !== void 0 ? extVariant : globalVariant;
    return {
      backgroundColor: variant === "lined" ? theme.palette.brand.boysenberry[200] : theme.palette.brand.boysenberry[100]
    };
  },
  twilioLight: function twilioLight(theme, _ref3) {
    var extVariant = _ref3.variant;

    var _useTabsContext3 = useTabsContext(),
        globalVariant = _useTabsContext3.variant;

    var variant = extVariant !== null && extVariant !== void 0 ? extVariant : globalVariant;
    return {
      backgroundColor: variant === "lined" ? theme.palette.twilio.gray[20] : theme.palette.twilio.blue[10]
    };
  }
});
/* harmony default export */ var Tabs_Track_Track = (Track_Track);
;// CONCATENATED MODULE: ../../libs/matcha/recipes/Tabs/Track/index.ts

;// CONCATENATED MODULE: ../../libs/matcha/recipes/Tabs/index.ts





Tabs_Tabs.displayName = "Tab.Base";
Tabs_Control_Control.displayName = "Tab.Control";
Tabs_Panel_Panel.displayName = "Tab.Panel";
Tabs_Track_Track.displayName = "Tab.Track";


/* harmony default export */ var recipes_Tabs = (Tabs_Tabs);

/***/ }),

/***/ 53834:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* reexport */ useTabs_useTabs; }
});

// EXTERNAL MODULE: ../../node_modules/next/dist/compiled/@babel/runtime/helpers/esm/toConsumableArray.js + 2 modules
var toConsumableArray = __webpack_require__(12741);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../node_modules/react-use/esm/useKey.js + 1 modules
var useKey = __webpack_require__(2095);
// EXTERNAL MODULE: ../../libs/utils/useScrollTo/useScrollTo.ts
var useScrollTo = __webpack_require__(32523);
;// CONCATENATED MODULE: ../../libs/matcha/recipes/Tabs/useTabs/useTabs.ts




/**
 * A hook for managing tab state and providing tab props.
 * @param {number} initialTab - The index of the initially active tab.
 * @param {number} numberOfTabs - Total number of tabs to cycle through.
 * @param {string} id - The id of the tab instance.
 *
 * @returns {object} An object containing several utility functions and state values for tab management.
 * @returns {number} activeTabKey - The index of the currently active tab.
 * @returns {function} setActiveTabKey - A function to set the active tab.
 * @returns {function} getControlProps - A function to get props for a tab control.
 * @returns {function} getPanelProps - A function to get props for a tab panel.
 * @returns {function} isActive - A function to check if a tab is active.
 */

var useTabs = function useTabs() {
  var initialTab = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
  var numberOfTabs = arguments.length > 1 ? arguments[1] : undefined;
  var id = arguments.length > 2 ? arguments[2] : undefined;

  var _useState = (0,react.useState)(initialTab),
      activeTabKey = _useState[0],
      setActiveTabKey = _useState[1];

  var trackRef = (0,react.useRef)(null);
  var scrollTo = (0,useScrollTo/* default */.Z)(trackRef);
  var tabRefs = Array.from({
    length: numberOfTabs
  }, function () {
    return /*#__PURE__*/(0,react.createRef)();
  });
  var uniqueTabIds = (0,react.useRef)((0,toConsumableArray/* default */.Z)(Array(numberOfTabs)).map(function () {
    return "".concat(id, "-").concat((0,react.useId)());
  }));

  var isEventFromTabRef = function isEventFromTabRef(e) {
    return tabRefs.some(function (ref) {
      return ref.current === e.target;
    });
  };

  var changeTab = (0,react.useCallback)(function (newTab) {
    if (newTab >= 0 && newTab < numberOfTabs) {
      setActiveTabKey(newTab);
    }
  }, []);
  var arrowRightHandler = (0,react.useCallback)(function (e) {
    if (!isEventFromTabRef(e)) return;
    var nextTab = (activeTabKey + 1) % numberOfTabs;
    changeTab(nextTab);
    scrollTo(tabRefs[nextTab]);
  }, [activeTabKey, numberOfTabs]);
  var arrowLeftHandler = (0,react.useCallback)(function (e) {
    if (!isEventFromTabRef(e)) return;
    var nextTab = (activeTabKey - 1 + numberOfTabs) % numberOfTabs;
    changeTab(nextTab);
    scrollTo(tabRefs[nextTab]);
  }, [activeTabKey, numberOfTabs]);
  (0,react.useEffect)(function () {
    var isAnyTabFocused = Object.values(tabRefs).some(function (ref) {
      return document.activeElement === ref.current;
    });

    if (tabRefs[activeTabKey].current && isAnyTabFocused) {
      var _tabRefs$activeTabKey;

      (_tabRefs$activeTabKey = tabRefs[activeTabKey].current) === null || _tabRefs$activeTabKey === void 0 ? void 0 : _tabRefs$activeTabKey.focus();
    }
  }, [activeTabKey, tabRefs]);
  var isActive = (0,react.useCallback)(function (value) {
    return value === activeTabKey;
  }, [activeTabKey]);
  (0,useKey/* default */.Z)("ArrowLeft", arrowLeftHandler, undefined, [activeTabKey, numberOfTabs]);
  (0,useKey/* default */.Z)("ArrowRight", arrowRightHandler, undefined, [activeTabKey, numberOfTabs]);
  var clickHandler = (0,react.useCallback)(function (value, ref) {
    if (!trackRef.current) {
      console.warn("[useTabs] trackRef is not passed to the DOM node!. Scroll will not work.");
    }

    setActiveTabKey(value);
    scrollTo(ref);
  }, [changeTab]);
  var getControlProps = (0,react.useCallback)(function (value) {
    var ref = tabRefs[value];
    var id = "tab-".concat(uniqueTabIds.current[value]);
    return {
      ref: ref,
      onClick: function onClick() {
        return clickHandler(value, ref);
      },
      'aria-selected': value === activeTabKey,
      tabIndex: value === activeTabKey ? undefined : -1,
      role: "tab",
      id: id,
      active: isActive(value)
    };
  }, [activeTabKey, isActive]);
  var getPanelProps = (0,react.useCallback)(function (value) {
    var id = "tab-panel-".concat(uniqueTabIds.current[value]);
    return {
      id: id,
      role: "tabpanel",
      'aria-labelledby': "tab-".concat(uniqueTabIds.current[value]),
      tabIndex: value === activeTabKey ? 0 : -1,
      key: value
    };
  }, [activeTabKey, isActive]);
  var getTrackProps = (0,react.useCallback)(function () {
    return {
      ref: trackRef,
      role: "tablist"
    };
  }, [trackRef]);
  return {
    activeTabKey: activeTabKey,
    setActiveTabKey: setActiveTabKey,
    getControlProps: getControlProps,
    getPanelProps: getPanelProps,
    isActive: isActive,
    getTrackProps: getTrackProps
  };
};

/* harmony default export */ var useTabs_useTabs = (useTabs);
;// CONCATENATED MODULE: ../../libs/matcha/recipes/Tabs/useTabs/index.ts


/***/ })

}]);